import MoreVertIcon from "@mui/icons-material/MoreVert"

import useStyle from "./useStyle"
import { useState } from "react"
import { Box, IconButton, Menu, Typography, Tooltip } from "@mui/material"

import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined"

import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

function TableItem({ item, setLoading }) {
  const navigate = useNavigate()
  const classes = useStyle()
  const [anchorEl, setAnchorEl] = useState(null)
  const { searchEvStatus } = useSelector((state) => state.eventanilla)
  const open = Boolean(anchorEl)
  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const formatDate = (date) => {
    if (!date) return ""

    try {
      const newDate = new Date(date)

      if (isNaN(newDate.getTime())) {
        return ""
      }

      const day = newDate.getUTCDate().toString().padStart(2, "0")
      const month = (newDate.getUTCMonth() + 1).toString().padStart(2, "0")
      const year = newDate.getUTCFullYear()

      return `${day}/${month}/${year}`
    } catch (error) {
      return ""
    }
  }

  const formatCuit = (cuit) => {
    if (!cuit) return ""
    return cuit.toString().replace(/-/g, "")
  }


  function getStatusComponent(tooltip = false, color = false) {
    const components = [
      {
        type: "EV NO AUTH",
        color: "#509b92ff",
        tooltip:
          "ACTIVE-LOAD-FAIL-NO-AUTH (Habilitado en EV pero se quitó la delegación del CUIT a Errepar)",
        text: "EV NO AUTH",
      },
      {
        type: "EV DESHABILITADO",
        color: "#509b92ff",
        tooltip:
          "DISABLED (Se habilitó en EV pero el usuario luego lo deshabilitó)",
        text: "EV DESHABILITADO",
      },
      {
        type: "EV CON ERROR",
        color: "#509b92ff",
        tooltip:
          "ACTIVE-LOAD-FAIL (Habilitado en EV pero la última consulta falló)",
        text: "EV CON ERROR",
      },
      {
        type: "EV PEND. ACEPTACION",
        color: "#509b92ff",
        tooltip:
          "WAITING-DELEGATION (Habilitado en EV pero falta la aceptación de la delegación)",
        text: "EV PEND. ACEPTACION",
      },
      {
        type: "OTRO",
        color: "#509b92ff",
        tooltip: "OTRO",
        text: "OTRO",
      },
      {
        type: "hasEV",
        color: "#4b916aff",
        tooltip: "E-ventanilla habilitado",
        text: "EV",
      },
      {
        type: "hasNotEV",
        color: "#b4ae40ff",
        tooltip: "No tiene E-ventanilla habilitado",
        text: "Falta EV",
      },
      {
        type: "isNotClient",
        color: "#b25353ff",
        tooltip: "El CUIT no es cliente",
        text: "No cliente",
      },
    ]

    function getData(type, key = null) {
      // console.log(type)
      const result = components
        .filter((comp) => key ? comp.type === key : comp.type === item.statusEV
        )
        .at(-1)
      return result?.[type] ?? ""
    }

    switch (item.statusEV) {
      case "EV NO AUTH":
      case "EV DESHABILITADO":
      case "EV CON ERROR":
      case "EV PEND. ACEPTACION":
        return getData(tooltip ? "tooltip" : color ? "color" : "text")
      case "OTRO":
      default:
        if (searchEvStatus === "Cliente con observaciones")
          return getData(tooltip ? "tooltip" : color ? "color" : "text")
        return getData(
          tooltip ? "tooltip" : color ? "color" : "text",
          item.hasEV && item.isClient
            ? "hasEV"
            : !item.hasEV && item.isClient
              ? "hasNotEV"
              : "isNotClient",
        )
    }
  }

  return (
    <tr className={classes.row}>
      <td className={classes.cuit}>
        {formatCuit(item.customerSuborganizationCuit)}
      </td>

      <td className={classes.name}>{item.customerSuborganizationName}</td>
      <td className={classes.date}>
        {formatDate(item?.accessDelegationDateTime)}
      </td>
      <td className={classes.status}>
        <Tooltip
          title={
            getStatusComponent(true)
          }
          arrow
        >
          <IconButton>
            <Typography
              className={classes.typographyStyle}
              style={{
                color: getStatusComponent(false, true),
                fontWeight: "bold",
              }}
            >
              {getStatusComponent()}
            </Typography>
          </IconButton>
        </Tooltip>
      </td>
      <td className={classes.user}>
        {item.delegationAcceptationUser?.split("@")[0]}
      </td>
      <td className={classes.note}>
        <Tooltip title={item.delegationNotes} arrow>
          <IconButton>
            <Typography className={classes.typographyStyle}>
              {item.delegationNotes}
            </Typography>
          </IconButton>
        </Tooltip>
      </td>
      <td className={classes.itemKebab}>
        <MoreVertIcon
          sx={{
            color: "#026873",
            "&:hover": {
              color: "#00FFAC",
            },
          }}
          onClick={handleClickButton}
        />

        <Menu
          id="basic-menu"
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <FiltersList
            onClose={handleClose}
            navigate={navigate}
            cuitValue={item.customerSuborganizationCuit}
            formData={item}
            classes={classes}
          />
        </Menu>
      </td>
    </tr>
  )
}

function FiltersList({ onClose, navigate, cuitValue, formData, classes }) {
  return (
    <Box
      sx={{
        width: 130,
      }}
      className={classes.boxStyle}
      onClick={onClose}
    >
      <IconButton
        onClick={() => {
          onClose()
          navigate(`detalleCliente/${cuitValue}`, { state: formData })
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>
    </Box>
  )
}

export default TableItem
